import cookies from 'js-cookie';
import moment from 'moment-timezone';
import 'moment/locale/pt-br';

import { getDiscoverFromCookie } from 'features/school';

export const formatDateFromUtcToTimezone = (date: any, tz: any = null) => {
  const userPreferredTimezone = cookies.get('tz');
  const discover = getDiscoverFromCookie();

  const timezone = tz || userPreferredTimezone || discover.schoolTimezone || 'America/Sao_Paulo';

  return moment.tz(date, timezone);
};

export default formatDateFromUtcToTimezone;
